export default "__VITE_ASSET__C5DjMc5U__"